










































import Vue from "vue";
import { LocaleMessages } from "vue-i18n";

import ListShareClipboardButton from "@/modules/company-lists/components/list-share/list-share-clipboard-button.vue";

export default Vue.extend({
  name: "SharePlannerActions",

  components: {
    ListShareClipboardButton,
  },

  props: {
    link: {
      type: String,
      required: true,
    },

    passcode: {
      type: String,
      required: true,
    },
  },

  computed: {
    settingsLinkCopy(): LocaleMessages {
      return this.$t("companyLists.list.linkSettings") as LocaleMessages;
    },

    copyLinkButtonCopy(): LocaleMessages {
      return this.$t("companyLists.list.copyLink") as LocaleMessages;
    },

    passcodeButtonCopy(): LocaleMessages {
      return this.$t("milestonePlanner.copyPasscode") as LocaleMessages;
    },

    shareModalTitle(): LocaleMessages {
      return this.$t(
        "milestonePlanner.shareModal.footer.title",
      ) as LocaleMessages;
    },

    shareModalCopy(): LocaleMessages {
      return this.$t(
        "milestonePlanner.shareModal.footer.subtitle.placeholders",
      ) as LocaleMessages;
    },

    isRestrictedByPasscode(): number {
      // Convert passcode length to a numeric boolean (empty = 0 / not-empty = 1)
      return +!!this.passcode.length;
    },
  },

  methods: {
    onClickSettingHandler() {
      this.$root.$emit("planner-settings", true);
    },
  },
});
